import { Modal } from "components";

import { useProductsPrices } from "../../context/provider";

const formatRate = (rate) => {
  const value = Number(rate);
  if (!Number.isFinite(value)) {
    return "—";
  }

  return value.toLocaleString("pl-PL", { maximumFractionDigits: 4 });
};

const ExchangeRatesModal = ({ is_open, handleClose }) => {
  const {
    state: { exchange_rates },
  } = useProductsPrices();

  if (!is_open) {
    return null;
  }

  const rates = Array.isArray(exchange_rates) ? exchange_rates : [];

  return (
    <Modal
      size="sm"
      handleClose={handleClose}
      header={{
        title: "Kursy walut",
      }}
    >
      {rates.length === 0 ? (
        <p>Brak kursów walut.</p>
      ) : (
        <table className="table">
          <tbody className="table__body table-body">
            {rates.map(({ currency, rate }) => (
              <tr key={currency}>
                <td>{String(currency || "").toUpperCase()}</td>
                <td>{formatRate(rate)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Modal>
  );
};

export default ExchangeRatesModal;
